
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoyLateralConicalRed as ObiSimplifiedBuoyLateralConicalRedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-lateral-conical-red.js';
 
 
 

 
 export const ObiSimplifiedBuoyLateralConicalRed = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-lateral-conical-red',
   elementClass: ObiSimplifiedBuoyLateralConicalRedElement,
   events: {
     
   }
  });
 
 